import * as React from 'react';
import { styled } from '@naan/stitches.config';
import __ from '@core/lib/localization';

const getThreeLetterDayOfweekNames = () => [
  __('Mon', 'threeLettersDoW:mon'),
  __('Tue', 'threeLettersDoW:tue'),
  __('Wed', 'threeLettersDoW:wed'),
  __('Thu', 'threeLettersDoW:thu'),
  __('Fri', 'threeLettersDoW:fri'),
  __('Sat', 'threeLettersDoW:sat'),
  __('Sun', 'threeLettersDoW:sun'),
];

const gweTwoLetterDayOfweekNames = () => [
  __('Mo', 'twoLettersDoW:mo'),
  __('Tu', 'twoLettersDoW:tu'),
  __('We', 'twoLettersDoW:we'),
  __('Th', 'twoLettersDoW:th'),
  __('Fr', 'twoLettersDoW:fr'),
  __('Sa', 'twoLettersDoW:sa'),
  __('Su', 'twoLettersDoW:su'),
];

const Wrapper = styled('div', {
  position: 'sticky',
  top: 0,
  backgroundColor: '$white',
  padding: '8px 0',
  marginTop: -8,
  marginBottom: 16,
  zIndex: 1,
  '@medium': {
    marginBottom: 32,
  },

  '& .inner': {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gridGap: '8px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    backgroundColor: '$gray-25',
    padding: '6px 0',
    textStyle: 'small-caps',
    userSelect: 'none',

    '& .dow': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '$gray-500',

      '& .d3l': {
        display: 'none',
      },
      '@medium': {
        '& .d2l': {
          display: 'none',
        },
        '& .d3l': {
          display: 'block',
        },
      },
    },
  },
});

export const CalendarHeader = () => {
  const twoLetterDayOfweekNames = gweTwoLetterDayOfweekNames();
  const threeLetterDayOfweekNames = getThreeLetterDayOfweekNames();
  return (
    <Wrapper>
      <div className="inner">
        {twoLetterDayOfweekNames.map((dayName, index) => (
          <div className="dow" key={dayName}>
            <span className="d2l">{dayName}</span>
            <span className="d3l">{threeLetterDayOfweekNames[index]}</span>
          </div>
        ))}
      </div>
    </Wrapper>
  );
};
